"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepWelcome = StepWelcome;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const StepWelcome_style_1 = require("./StepWelcome.style");
function StepWelcome() {
    return ((0, jsx_runtime_1.jsxs)(StepWelcome_style_1.WelcomeStepWrapper, { children: [(0, jsx_runtime_1.jsx)(StepWelcome_style_1.Heading, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.welcome.heading" }) }), (0, jsx_runtime_1.jsx)(StepWelcome_style_1.FriendsWaveImage, {}), (0, jsx_runtime_1.jsx)(StepWelcome_style_1.TextWrapper, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.welcome.text" }) })] }));
}
